/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const UPDATE_ACTION = gql`
  mutation UpdateAction($input: UpdateActionInput!) {
    updateAction(data: $input)
  }
`
